import React from 'react';
import {FastField,} from 'formik';
import {MDBPopover, MDBPopoverBody} from 'mdbreact';
import {Case, Switch,} from 'react-if';
import CompanyAutoCompleteInputContainer from 'data/redux/containers/companyAutoCompleteInputContainer';
import AirlineSelectorContainer from 'data/redux/containers/airlineSelectorContainer';
import {eVoucherTypes} from 'data/enums/products';

export interface IVoucherDetails {
  type: eVoucherTypes;

}

interface ICompanyNameTypeSwitchProps {
  values: IVoucherDetails;
  setFieldValue: any;
}

const CompanyNameTypeSwitch = (props: ICompanyNameTypeSwitchProps) => {
  return (
    <MDBPopover
      placement="top"
      popover
      clickable
      domElement={true}
    >
      <div>
        <Switch>
          <Case condition={props.values.type === eVoucherTypes.flightCompanies}>{() =>
            <FastField
              component={AirlineSelectorContainer}
              label="חברת תעופה (יש לרשום באנגלית) *"
              name="flightCompanyDetails"
            />}
          </Case>
          <Case condition={props.values.type === eVoucherTypes.agencies}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="חברת סוכנות (יש לרשום באנגלית) *"
              name="companyDetails"
              onChange={(e) => {
                
                props.setFieldValue('companyDetails', e);
              }}
            />
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.hotels}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="מלון (יש לרשום באנגלית) *"
              name="companyDetails"
            />
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.cruise}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="חברת שייט (יש לרשום באנגלית) *"
              name="companyDetails"
            />
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.restaurant}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="מסעדה (יש לרשום באנגלית) *"
              name="companyDetails"
            />
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.restaurants}>{() =>
            <>
              <FastField
                component={CompanyAutoCompleteInputContainer}
                label="מפיק השובר: בית העסק, ביימיי,...., אחר *"
                name="companyDetails"
              />
            </>
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.shop}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="שם חנות *"
              name="companyDetails"
            />
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.shops}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="מפיק השובר: בית העסק, ביימיי,...., אחר"
              name="companyDetails"
            />
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.experience}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="שם חנות *"
              name="companyDetails"
            />
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.experiences}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="מפיק השובר: בית העסק, ביימיי,...., אחר"
              name="companyDetails"
            />
          }
          </Case>
          <Case condition={props.values.type === eVoucherTypes.multi}>{() =>
            <FastField
              component={CompanyAutoCompleteInputContainer}
              label="מפיק השובר: בית העסק, ביימיי,...., אחר"
              name="companyDetails"
            />
          }
          </Case>
        </Switch>
      </div>
      <div>
        <MDBPopoverBody>
          לדוגמא ISSTA, EL AL ועוד...
        </MDBPopoverBody>
      </div>
    </MDBPopover>
  );
};

CompanyNameTypeSwitch.defaultProps = {
  values: {},
  setFieldValue: () => null,
};

export default React.memo(CompanyNameTypeSwitch);
